import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { GuidePouchContent } from '@libs/shared/interfaces/couch/models/guide';

@Injectable({
  providedIn: 'root',
})
@StoreConfig({
  name: 'guide',
  idKey: '_id',
})
export class GuideStore extends EntityStore<EntityState<GuidePouchContent, string>, GuidePouchContent> {
  constructor() {
    super();
  }
}
